import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { withShowOnce } from "../../withShowOnce";

import { TooltipStep2 } from "./TooltipStep";

export interface MinitourProps {
    minitourEnabled?: boolean | Function;
    openedFrom?: string;
    id: string;
}

const mapStateToProps = (state: FullFormState, ownProps: MinitourProps) => {
    let minitourEnabled = true;
    if (typeof ownProps.minitourEnabled === "function") {
        minitourEnabled = ownProps.minitourEnabled.call(this, state);
    } else if (typeof ownProps.minitourEnabled === "boolean") {
        minitourEnabled = ownProps.minitourEnabled;
    }
    const minitourId = ownProps.id;

    return {
        id: minitourId,
        minitourEnabled: minitourEnabled,
        openedFrom: ownProps.openedFrom ?? minitourId,
        userId: state.settings.userId,
    };
};

export const TooltipStepContainer = connect(mapStateToProps)(withShowOnce(TooltipStep2));
